import React from 'react'
import QRCode from 'react-qr-code'

function QRcodeComponent(props) {
  const { val = 'https://www.nuskin.com/us/en/', size = 256 } = props
  return (
    <div className="nu-qrcode">
      <QRCode value={val} size={size} />
    </div>
  )
}

export default QRcodeComponent
export { QRcodeComponent }
